import http from '@core/fetch'
export default {
  // 新增，编辑咨询礼

  addConsultGiftConfig: body =>
    http.post('/p/wedding/Admin/APIMerchantPrivilege/add', {
      body
    }),
  // 新增，编辑咨询礼
  editConsultGiftConfig: body =>
    http.post('/p/wedding/Admin/APIMerchantPrivilege/edit', {
      body
    }),
  // 获取商家咨询礼配置
  getConsultGiftConfig: body =>
    http('/p/wedding/Admin/APIMerchantPrivilege/current_list', { body })
}
